import React, { Fragment, useContext, useState } from "react";
import {
  Col,
  Container,
  Row,
  Button,
  Table,
  Form,
  CardHeader,
  CardBody,
} from "reactstrap";
import useAxios from "../../../Utils/useAxios";
import { useNavigate } from "react-router-dom";
import { formatRP } from "../../../Utils/externalFunctions";
import { FORM_TYPE } from "../../../Constant/FormType";
import { APISentSuccessMsg } from "../../../Constant/Message";
import { useThemeContext } from "../../../Context/ThemeContext";
import { getDarkTableRow } from "../../../Utils/otherFunctions";
import {
  createAnggaranDipakaiRealokasi,
  createAnggaranDipakaiRealokasiNontarget,
  createRealokasi,
  updateRealokasi,
} from "../services";

const StepEmpat = ({
  prevStep,
  total,
  formRealokasi,
  rencImp,
  anggaranRencimpRealokasi,
  selectedRencImp,
  formType,
}) => {
  const axiosInstance = useAxios();
  const navigate = useNavigate();
  const [waitingForSubmit, setWaitingForSubmit] = useState(false);

  const { themeContext } = useThemeContext();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setWaitingForSubmit(true);

      const response =
        formType === FORM_TYPE.Create
          ? await createRealokasi(axiosInstance, formRealokasi)
          : await updateRealokasi(
              axiosInstance,
              formRealokasi.id,
              formRealokasi
            );

      if (response.status === 201 || response.status === 200) {
        console.log(APISentSuccessMsg);

        const response =
          formRealokasi.is_target === "t"
            ? await createAnggaranDipakaiRealokasi(
                axiosInstance,
                anggaranRencimpRealokasi
              )
            : await createAnggaranDipakaiRealokasiNontarget(
                axiosInstance,
                anggaranRencimpRealokasi
              );

        if (response.status === 201) {
          navigate(`${process.env.PUBLIC_URL}/realokasi/`);
        }
      }
    } finally {
      setWaitingForSubmit(false);
    }
  };

  const findRencImp = (id) => {
    const itemWithId = rencImp.find((item) => item.pk === id);
    return itemWithId ? itemWithId : "Unknown";
  };

  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Form className="needs-validation">
              <Row className="justify-content-md-center">
                <Col md="4">
                  <CardHeader className="pb-3 text-center mt-4">
                    <h2>
                      <strong>Konfirmasi Realokasi</strong>
                    </h2>
                  </CardHeader>
                  <Table hover>
                    <tbody>
                      <tr>
                        <td
                          className={
                            "align-center" + getDarkTableRow(themeContext)
                          }
                        >
                          <strong>DPSJ</strong>
                        </td>
                        <td>{selectedRencImp.nm_org}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Kegiatan</strong>
                        </td>
                        <td>
                          <p>
                            {selectedRencImp.kd_keg} - {selectedRencImp.nm_keg}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Akun</strong>
                        </td>
                        <td>
                          <p>
                            {selectedRencImp.kd_akun} -{" "}
                            {selectedRencImp.nm_akun}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Sisa Anggaran</strong>
                        </td>
                        <td>
                          <p>
                            Rp. {formatRP(selectedRencImp.anggaran_tersisa)}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Anggaran Realokasi</strong>
                        </td>
                        <td>
                          <p>Rp. {formatRP(formRealokasi.nilai_anggaran)}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Keterangan</strong>
                        </td>
                        <td>
                          <p>{formRealokasi.keterangan}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Alasan</strong>
                        </td>
                        <td>
                          <p>{formRealokasi.alasan}</p>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>

              <CardBody></CardBody>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col sm="12">
            <Table responsive>
              <thead>
                <tr>
                  <th className={getDarkTableRow(themeContext)}>Tahun</th>
                  <th className={getDarkTableRow(themeContext)}>Kegiatan</th>
                  <th className={getDarkTableRow(themeContext)}>
                    Sisa Anggaran (Rp)
                  </th>
                  <th className={getDarkTableRow(themeContext)}>Jumlah</th>
                </tr>
              </thead>
              <tbody>
                {anggaranRencimpRealokasi.map((art) => (
                  <tr key={art.rencana_imp}>
                    <td scope="row" className={getDarkTableRow(themeContext)}>
                      2023
                    </td>
                    <td className={getDarkTableRow(themeContext)}>
                      {findRencImp(parseInt(art.rencana_imp)).kd_keg}-
                      {findRencImp(parseInt(art.rencana_imp)).nm_keg}
                    </td>
                    <td className={getDarkTableRow(themeContext)}>
                      {formatRP(
                        findRencImp(parseInt(art.rencana_imp)).anggaran_tersisa
                      )}
                    </td>
                    <td className={getDarkTableRow(themeContext)}>
                      {formatRP(art.anggaran_digunakan)}
                    </td>
                  </tr>
                ))}
                <tr>
                  <th
                    scope="row"
                    className={getDarkTableRow(themeContext)}
                  ></th>
                  <td className={getDarkTableRow(themeContext)}></td>
                  <td className={getDarkTableRow(themeContext)}>
                    <strong>Total</strong>
                  </td>
                  <td className={getDarkTableRow(themeContext)}>
                    Rp. {formatRP(total)}
                  </td>
                </tr>
              </tbody>
            </Table>

            <div className="row justify-content-between m-4">
              <div className="col-auto">
                <Button onClick={prevStep}>Kembali</Button>
              </div>
              <div className="col-auto">
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={waitingForSubmit}
                >
                  Submit
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default StepEmpat;
